import * as Yup from "yup";
export const validationSchema = Yup.object().shape({
  company_profile_value: Yup.string().required("The company profile field is required."),
  company_profile_value_french: Yup.string().required("The company profile (French) field is required."),
  company_profile_value_dutch: Yup.string().required("The company profile (Dutch) field is required."),
});
